import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "animate.css/animate.min.css";
import { WOW } from "wowjs";
import Preloader from "../components/Preloader";
import ScrollToTop from "../components/ScrollToTop";
import LoadTop from "../components/ScrollToTop/LoadTop";
import FloatingActions from "../components/FloatingActions";

import {
  About,
  Appointment,
  Blog,
  BlogDetails,
  BlogSidebar,
  Vlogs,
  Cart,
  CeoMessage,
  ChairmanMessage,
  Checkout,
  Compare,
  Contact,
  Error,
  Faq,
  HomeFour,
  Login,
  OurStory,
  PatientLogin,
  PatientProfile,
  MyAppointments,
  MyReports,
  Portfolio,
  PortfolioDetails,
  Price,
  Register,
  Service,
  ServiceDetails,
  ShopColumnFour,
  ShopColumnThree,
  ShopDetails,
  ShopSidebar,
  Team,
  TeamDetails,
  Testimonial,
  VisionMission,
  Wishlist,
  DepartmentDetails,
  Departments,
  SpecialityDetails,
  DoctorProfile,
  OurDoctors,
  EServices,
  EServiceDetail,
  Careers,
  CareerDetail,
  ResearchHome,
  ResearchDirectorMessage,
  ResearchVisionMission,
  ResearchClinicalTrials,
  ResearchRegulatory,
  ResearchIRB,
  ResearchCertifications,
  ResearchConferences,
  ResearchTeam,
  ResearchContact,
} from "../pages";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  //Initialize preloader
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, []);

  // Initialize wowjs and animate.css
  useEffect(() => {
    new WOW({ live: false, animateClass: "animate__animated" }).init();
  }, [location]);

  return (
    <div className="App">
      {isLoading && <Preloader />}
      <ScrollToTop />
      <LoadTop />
      <Routes>
        <Route path="/" element={<HomeFour />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/our-story" element={<OurStory />} />
        <Route path="/chairman-message" element={<ChairmanMessage />} />
        <Route path="/ceo-message" element={<CeoMessage />} />
        <Route path="/vision-mission" element={<VisionMission />} />
        <Route path="/service" element={<Service />} />
        <Route path="/service/:id" element={<ServiceDetails />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/portfolio-details" element={<PortfolioDetails />} />
        <Route path="/team" element={<Team />} />
        <Route path="/team-details" element={<TeamDetails />} />
        <Route path="/testimonial" element={<Testimonial />} />
        <Route path="/departments" element={<Departments />} />
        <Route path="/department/:id" element={<DepartmentDetails />} />
        <Route path="/speciality/:id" element={<SpecialityDetails />} />
        <Route path="/doctor/:id" element={<DoctorProfile />} />
        <Route path="/our-doctors" element={<OurDoctors />} />
        <Route path="/e-services" element={<EServices />} />
        <Route path="/e-services/:id" element={<EServiceDetail />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/careers/:id" element={<CareerDetail />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/price" element={<Price />} />
        <Route path="/appointment" element={<Appointment />} />
        <Route path="/shop-column-3" element={<ShopColumnThree />} />
        <Route path="/shop-column-4" element={<ShopColumnFour />} />
        <Route path="/shop-sidebar" element={<ShopSidebar />} />
        <Route path="/shop/:productId" element={<ShopDetails />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/compare" element={<Compare />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/patient-login" element={<PatientLogin />} />
        <Route path="/patient-profile" element={<PatientProfile />} />
        <Route path="/my-appointments" element={<MyAppointments />} />
        <Route path="/my-reports" element={<MyReports />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog-sidebar" element={<BlogSidebar />} />
        <Route path="/blog-details" element={<BlogDetails />} />
        <Route path="/blog/:id" element={<BlogDetails />} />
        <Route path="/vlogs" element={<Vlogs />} />
        <Route path="/contact" element={<Contact />} />

        {/* ─── Research Microsite ─── */}
        <Route path="/research" element={<ResearchHome />} />
        <Route path="/research/director-message" element={<ResearchDirectorMessage />} />
        <Route path="/research/vision-mission" element={<ResearchVisionMission />} />
        <Route path="/research/clinical-trials" element={<ResearchClinicalTrials />} />
        <Route path="/research/regulatory" element={<ResearchRegulatory />} />
        <Route path="/research/irb" element={<ResearchIRB />} />
        <Route path="/research/certifications" element={<ResearchCertifications />} />
        <Route path="/research/conferences" element={<ResearchConferences />} />
        <Route path="/research/team" element={<ResearchTeam />} />
        <Route path="/research/contact" element={<ResearchContact />} />

        <Route path="*" element={<Error />} />
      </Routes>
      <FloatingActions />
    </div>
  );
}

export default App;
